import { Card, Div, Flex, HelpButton, P } from '@dnb/eufemia';
import { CurrentApiAndScopeEntitlementsDto } from '@portals/shared/portal/AppApiEntitlementDto';

import TogglableScopeList from '../ToggleableScopeTable';

import style from './index.module.css';

interface Props {
  availableApiAndScopeEntitlements: CurrentApiAndScopeEntitlementsDto[];
  isLiveClient: boolean;
  extraScopesInClient: string[];
}

export function ApiScopeEntitlementCard({
  availableApiAndScopeEntitlements,
  isLiveClient,
  extraScopesInClient,
}: Props) {
  if (availableApiAndScopeEntitlements.length === 0 && extraScopesInClient.length === 0) {
    return <P>No API entitlements available in this environment</P>;
  }

  return (
    <Flex.Stack gap="small" wrap={false}>
      {availableApiAndScopeEntitlements
        .map((entitlement) => {
          const scopeEntitlementNames = entitlement.scopeEntitlements
            .filter((s) => s.liveMode === isLiveClient)
            .map((scopeEntitlement) => scopeEntitlement.scopeName);

          if (scopeEntitlementNames.length === 0) {
            return null;
          }

          return (
            <Card
              className={style['FullWidthTable']}
              innerSpace={0}
              key={entitlement.api.id}
              title={entitlement.api.name}
            >
              <TogglableScopeList scopeEntitlementNames={scopeEntitlementNames} />
            </Card>
          );
        })
        .filter(Boolean)
        .toSorted((a, b) => a!.props.title.localeCompare(b!.props.title))}
      {extraScopesInClient.length > 0 && (
        <Card
          backgroundColor="sand-yellow"
          className={style['FullWidthTable']}
          innerSpace={0}
          title={
            <P>
              Extra scopes
              <HelpButton left="x-small" size="small" title="Extra scopes">
                <Div top="small">
                  Extra scopes are scopes that the client has access to, but that the app it belongs to does not have
                  entitlements for.
                </Div>
                <Div top="small">
                  This is common if the client was imported and should be resolved by requesting the same scope
                  entitlements for the app as well.
                </Div>
                <Div top="small">
                  Be cautious that if any of these scopes are removed, then they can only be added back after the app
                  has entitlements for the scopes as well.
                </Div>
              </HelpButton>
            </P>
          }
        >
          <TogglableScopeList scopeEntitlementNames={extraScopesInClient} />
        </Card>
      )}
    </Flex.Stack>
  );
}
